import { useState, useRef } from 'react';
import { postFormData } from '../../services/apiService';

interface ImageUploadFieldProps {
  label: string;
  currentUrl?: string | null;
  uploadEndpoint: string;
  onUploaded: (url?: string) => void;
  fieldName?: string;
}

export function ImageUploadField({ label, currentUrl, uploadEndpoint, onUploaded, fieldName = 'file' }: ImageUploadFieldProps) {
  const [uploading, setUploading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);

  const displayUrl = previewUrl || currentUrl || null;

  async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;

    setPreviewUrl(URL.createObjectURL(file));
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append(fieldName, file);
      const result = await postFormData<{ url?: string }>(uploadEndpoint, formData);
      onUploaded(result?.url);
    } catch {
      setPreviewUrl(null);
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      {displayUrl && (
        <img
          src={displayUrl}
          alt={label}
          className="w-32 h-32 object-cover rounded-lg border border-gray-200 mb-2"
        />
      )}
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        disabled={uploading}
        className="block text-sm text-gray-500 file:mr-4 file:py-1.5 file:px-3 file:rounded-lg file:border file:border-gray-300 file:text-sm file:font-medium file:bg-white file:text-gray-700 hover:file:bg-gray-50"
      />
      {uploading && <p className="text-xs text-blue-600 mt-1">Uploading...</p>}
    </div>
  );
}
